<template>
  <v-container fluid :class="{'px-0':esMovil}">
    <v-row no-gutters>
      <v-col cols="12">

        <v-alert v-if="!cargandoListado && paginas === 0" type="info" class="ma-12">
          <span class="body-1">{{ $t('sin_registros') }}</span>
        </v-alert>

        <v-alert v-if="cargandoListado && paginas === 0" type="info" class="ma-12">
          <span class="body-1">{{ $t('cargando_registros') }}</span>
          <v-progress-circular color="primary" :indeterminate="true"/>
        </v-alert>

        <div v-if="paginas > 0">
          <v-toolbar color="primary white--text" elevation="0">
            <v-toolbar-title class="font-weight-bold">
              {{ $tc('registro_descarga', 2) | capitalize }}
            </v-toolbar-title>

            <v-spacer/>
            <template>
              <v-btn icon color="white" :loading="cargandoListado" @click="obtenerRegistrosDescargas()">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
          </v-toolbar>

          <v-list>
            <div v-if="cargandoListado">
              <v-skeleton-loader v-for="i in porPagina" :key="i"
                                 ref="skeleton"
                                 type="list-item-two-line"
                                 class="mx-auto"
              ></v-skeleton-loader>
            </div>
            <div v-if="!cargandoListado">
              <v-list-item v-for="(registro,index) in listado" :key="index" three-line-line
                           class="registro-item">
                <v-list-item-content>
                  <v-list-item-title>
                    <span>{{ $t('tipo') | capitalize }}: </span>
                    <span class="primary--text font-weight-bold">{{ registro.tipo }}</span>
                    &nbsp;<span>{{ $t('fichero') | capitalize }}: </span>
                    <span class="primary--text font-weight-bold">{{ registro.fichero }}</span>
                  </v-list-item-title>

                  <v-list-item-subtitle class="body-1 font-italic">
                    <span class="font-weight-bold">{{ $tc('fecha', 1) | capitalize }}:</span>
                    {{ registro.createdAt | formatTimestamp }}
                    <span class="font-weight-bold">{{ $t('por') | capitalize }}:</span>
                    &nbsp;<span v-if="registro.usuario">
                                {{ registro.usuario.nombre }} ({{ registro.usuario.empresa }})
                                </span>
                    <span v-if="!registro.usuario">{{ $t('sin_usuario') }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list>

          <div class="text-center">
            <v-pagination circle v-model="pagina" :length="paginas" :disabled="cargandoListado"/>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="datosInforme != null">
      <v-col cols="12">
        <v-toolbar color="primary white--text" elevation="0">
          <v-toolbar-title class="font-weight-bold">
            {{ $tc('total', 2) | capitalize }}
          </v-toolbar-title>

          <v-spacer/>
          <template>
            <v-select dark v-model="anyoInforme" :items="anyos" class="select-anyo" hide-details/>
            <v-btn icon color="white" :loading="cargandoInforme" @click="obtenerInformeAnyo()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
        </v-toolbar>
      </v-col>
      <v-col v-show="cargandoInforme" :cols="esMovil ? 12 : 3" v-for="sk in 6" :key="'sklt-' + sk">
        <v-skeleton-loader type="image" max-height="54"/>
      </v-col>

      <v-col v-show="!cargandoInforme" :cols="esMovil ? 12 : 3" v-for="valor in valoresInforme" :key="valor.nombre">
        <v-card>
          <v-card-text class="font-weight-bold">
            {{ $t(valor.nombre) | capitalize }}: {{ valor.valor }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-toolbar color="primary white--text" :height="40" elevation="0">
          <v-toolbar-title class="font-weight-bold">
            {{ $tc('total', 1) | capitalize }}:&nbsp;{{ datosInforme.total }}
          </v-toolbar-title>
        </v-toolbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {MOSTRAR_SNACKBAR} from "@/store/store-app";
import FechasHelper from "@/comunes/helpers/FechasHelper";

export default {
  name: 'AdminRegistroDescargas',
  components: {},
  data: () => ({
    listado: [],
    cargandoListado: false,
    pagina: 1,
    porPagina: 4,
    total: 0,
    anyoInforme: null,
    cargandoInforme: false,
    datosInforme: null
  }),
  computed: {
    esMovil() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    paginas() {
      if (this.total === 0) return 0;

      let division = this.total / this.porPagina;
      return Math.trunc(division) + (division - Math.trunc(division) > 0 ? 1 : 0);
    },
    anyos() {
      let anyos = [];
      let anyoInicio = parseInt(FechasHelper.year()) - 5;
      for (let i = 0; i < 10; i++) anyos.push(anyoInicio + i)
      return anyos;
    },
    valoresInforme() {
      if (this.datosInforme == null) return [];
      let datos = [];
      Object.keys(this.datosInforme).forEach((key) => {
        if (key !== "year" && key !== "total")
          datos.push({nombre: key, valor: this.datosInforme[key]});
      });
      return datos;
    }
  },
  mounted: function () {
    this.obtenerRegistrosDescargas();
    this.anyoInforme = parseInt(FechasHelper.year());
  },
  watch: {
    pagina: function () {
      this.obtenerRegistrosDescargas();
    },
    anyoInforme: function () {
      this.obtenerInformeAnyo();
    }
  },
  methods: {
    obtenerRegistrosDescargas() {
      this.cargandoListado = true;
      let params = {
        pagina: this.pagina,
        porPagina: this.porPagina
      };

      HttpHelper.get(`admin/registro-descargas/listado`, params)
          .then((respuesta) => {
            this.listado = respuesta.content;
            this.total = respuesta.totalElements;
          })
          .catch((error) => {
            let msg = error && Object.prototype.hasOwnProperty.call(error, 'mensaje')
                ? error.mensaje : this.$t('error_listado');

            this.$store.commit(MOSTRAR_SNACKBAR, {
              texto: msg,
              color: "error"
            });
          })
          .finally(() => {
            this.cargandoListado = false;
          })
    },
    obtenerInformeAnyo() {
      this.cargandoInforme = true;
      HttpHelper.get(`admin/registro-descargas/informe-por-anyo`, {anyo: this.anyoInforme})
          .then((respuesta) => {
            this.datosInforme = respuesta;
          })
          .catch((error) => {
            let msg = error && Object.prototype.hasOwnProperty.call(error, 'mensaje')
                ? error.mensaje : this.$t('error_informe');

            this.$store.commit(MOSTRAR_SNACKBAR, {
              texto: msg,
              color: "error"
            });
          })
          .finally(() => {
            this.cargandoInforme = false;
          })
    }
  }
};
</script>

<style lang="scss" scoped>
.v-alert.info {
  background-color: #f7d9cd !important;
  color: #40108e !important;

  .v-icon {
    color: #40108e;
    font-size: 30px;
    margin-top: 5px;
  }
}

.registro-item {
  min-height: 72px;
  max-height: 72px;
}

.select-anyo {
  max-width: 80px;
}
</style>

<!-- @formatter:off -->
<i18n>
{
  "es": {
    "tipo": "tipo",
    "fichero": "fichero",
    "sin_usuario": "Sin usuario",
    "sin_registros": "Todavía no existe ningún registro de descarga",
    "cargando_registros": "Cargando registros de descarga",
    "error_listado": "No se ha podido obtener el listado de los registros de descarga",
    "error_informe": "No se ha podido obtener el informe de los registros de descarga",
    "registro_descarga": "registro descarga | registros descargas",
    "descargasDocumentos": "descargas de documentos",
    "descargasPdf": "descargas de proyectos",
    "descargasSinUsuario": "descargas sin usuario",
    "descargasConUsuario": "descargas con usuario",
    "descargasPdfSinUsuario": "descargas de proyectos sin usuario",
    "descargasPdfConUsuario": "descargas de proyectos con usuario"
  }
}
</i18n>
<!-- @formatter:on -->